<template>
  <div v-if="currentPlan" class="bg-white rounded-2xl shadow-lg border border-gray-200 p-4 sm:p-6 max-w-2xl mx-auto">
    <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div class="flex items-center space-x-4 w-full">
        <div class="w-12 h-12 bg-gradient-to-br from-primary to-primary-dark rounded-xl flex items-center justify-center shadow-sm">
          <span class="material-symbols-outlined text-white text-2xl">workspace_premium</span>
        </div>
        <div>
          <p class="text-sm text-gray-500">Current Plan</p>
          <p class="text-xl sm:text-2xl font-bold text-gray-900 capitalize">{{ currentPlan.name }}</p>
        </div>
      </div>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 w-full sm:w-auto">
        <span class="inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-medium shadow-sm"
          :class="{'bg-green-100 text-green-800': currentPlan.active, 'bg-red-100 text-red-800': !currentPlan.active}">
          {{ currentPlan.active ? 'Active' : 'Inactive' }}
        </span>
        <router-link 
          v-if="currentPlan.name !== 'free'" 
          to="/subscription-management" 
          class="w-full sm:w-auto text-primary hover:text-primary-dark text-sm font-medium flex items-center justify-center gap-1 px-3 py-1 rounded-full bg-primary-lighter hover:bg-primary-light transition-all duration-200"
        >
          Manage
          <span class="material-symbols-outlined text-sm">arrow_forward</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrentPlanStatus',
  props: {
    currentPlan: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped>
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.shadow-lg {
  box-shadow: 0 10px 25px -5px rgba(80, 36, 255, 0.1), 0 10px 10px -5px rgba(80, 36, 255, 0.04);
}
.rounded-2xl {
  border-radius: 1rem;
}
@media (max-width: 640px) {
  .gap-4 {
    gap: 1rem;
  }
  .gap-2 {
    gap: 0.5rem;
  }
  .sm\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\:p-6 {
    padding: 1rem;
  }
}
</style>
